var React = require('react');

function Bag24x24 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Products=off, Invert=Off","stroke":"currentColor","strokeWidth":"2","strokeMiterlimit":"10"},[React.createElement("path",{"id":"Vector","d":"M18.5 6h-13A1.5 1.5 0 004 7.5v14A1.5 1.5 0 005.5 23h13a1.5 1.5 0 001.5-1.5v-14A1.5 1.5 0 0018.5 6z","key":0}),React.createElement("path",{"id":"Vector_2","d":"M8.336 6.25A3.438 3.438 0 018 4.75c0-.995.421-1.948 1.172-2.652A4.14 4.14 0 0112 1a4.14 4.14 0 012.828 1.098A3.635 3.635 0 0116 4.75a3.437 3.437 0 01-.336 1.5","key":1})]));
}

Bag24x24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Bag24x24;

Bag24x24.default = Bag24x24;
